<script lang="ts" setup>
const error: any = useError()
const config = useRuntimeConfig()
</script>
<template>
  <article>
    <img
      :src="`${config.app.cdnURL}/${config.public.PUBLIC_IMAGES_URL}/500.png`"
      alt="500"
      width="462"
      height="259"
      class="d-block img-fluid mx-auto mb-8"
    >
    <h1 class="text-black text-center">
      {{ error?.statusCode }} error
    </h1>
    <Typo>
      <p class="delta text-center">
        {{ $t('Ospravedlňujeme sa, ale niečo sa pokazilo.') }}
      </p>
      <p class="text-center fs-big">
        {{
          $t(
            'Chybu sme zaznamenali a budeme sa ju snažiť opraviť čo najskôr.'
          )
        }}
      </p>
    </Typo>
    <div class="pt-12 pt-md-20 border-top mt-20 mt-md-40">
      <LazyWidgetHelpdeskExt />
    </div>
  </article>
</template>
